<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-select v-model="form.search_type" placeholder="">
                      <el-option
                        v-for="item in search_type"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.key_word"
                      placeholder="关键字"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_assignment"
                      placeholder="是否来源拣货任务"
                    >
                      <el-option
                        v-for="item in is_assignment"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="核查时间：">
                    <el-date-picker
                      v-model="form.create_time"
                      :default-time="['06:00:00', '06:00:00']"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="reset">重置</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <el-row
          :span="24"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-col :span="8">数据列表：</el-col>
          <el-col :span="16" style="text-align: right">
            <el-button type="success" style="" size="mini" @click="output(1)">
              导出</el-button
            >
          </el-col>
        </el-row>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="dbid"
              label="打标id"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sku"
              label="sku编号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop=""
              label="颜色/尺码"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.co_val }}/{{ scope.row.si_val }}
              </template>
            </el-table-column>
            <el-table-column
              prop="wave_picking_no"
              label="波次单号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_type"
              label="波次类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="picking_assignment_no"
              label="拣货任务"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_recheck_detail_is_assignment"
              label="是否来源拣货任务"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="shipping_space"
              label="仓位"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="核查人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="核查时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {
        setting: "未配置数据",
      },
      form: {
        page: 1,
        pagesize: 50,
        search_type: 1,
        wprlid: this.$route.params.id,
      },
      loading: false,
      url: "/erp/WavePickingRecheckLog/recheckLogDetail",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      msg: "",
      param: "",
      is_summary: 0, // 勾选的是否有汇总单的数据
      search_type: [
        { key: 1, name: "打标id" },
        { key: 2, name: "SKU编号" },
        // {"key" : 3, "name" : "波次单号"},
        { key: 4, name: "核查人" },
        { key: 5, name: "拣货任务" },
      ],
      is_assignment: [
        { key: "", name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },

  // created() {
  //     this.fetchData()
  // },
  methods: {
    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    searchDate() {
      const endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 06:00:00`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate());
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 06:00:00`;
      return [start, end];
    },

    output(val) {
      this.form.is_excel = val;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.loading = false;
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },

    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData(true);
    },
    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.fetchData(true);
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.origin = this.resData.origin;
        }
      });
    },
    reset() {
      this.form = {
        page: 1,
        pagesize: 50,
        search_type: 1,
        wprlid: this.$route.params.id,
      };
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.tab-div {
  border: 1px solid #ddd;
  margin: 20px 0;
  padding: 10px 0 10px 20px;
}

.tag-css {
  margin-left: 10px;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.el-dropdown-menu__item {
  background-color: #f56c6c;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/RecheckLogDetail.vue